import React, { useState, useEffect } from 'react';

import { dataGridPremiumColumns } from '../../utils/helper';
import { ColorCircleUi, DataGridIdentifiers, DatagridPremiumUi, OrderArrowsUI } from '../Interface';
import { filter } from 'lodash';
import tagService from '../../service/tag.service';
import { TagTargetList, TagTypeList } from '../../config/tag';

const TagReports = ({ refetch, values, viewField, operatorsDisabled, rowSelection }) => {
  const { refetchTable, setRefetchTable } = refetch;
  const { setSelectedValues } = values;
  const { rowSelectionModel, setRowSelectionModel } = rowSelection;

  const [reports, setReports] = useState({ rows: [], rowCount: 0 });

  const initialState = {
    filter: { filterModel: { items: [], logicOperator: 'and' } },
    sorting: {
      sortModel: [{ field: 'name', sort: 'asc' }],
    },
    pagination: {
      paginationModel: {
        pageSize: 25,
        page: 0,
      },
    },
    density: 'compact',
  };

  useEffect(() => {
    if (operatorsDisabled) {
      setRowSelectionModel([]);
    }
  }, [operatorsDisabled]);

  const getList = (gridState) => {
    tagService.getItems(gridState).then((data) => {
      setReports(data);
    });
  };

  const columns = dataGridPremiumColumns([
    {
      field: 'name',
      headerName: 'Megnevezés',
      type: 'string',
    },
    {
      field: 'tagType',
      headerName: 'Típus',
      type: 'singleSelect',
      valueOptions: TagTypeList,
    },
    {
      field: 'tagTarget',
      headerName: 'Cél',
      type: 'singleSelect',
      valueOptions: TagTargetList,
    },
    {
      field: 'externalCode',
      headerName: 'Külső azonosító',
      type: 'string',
    },
    {
      field: 'color',
      headerName: 'Szín',
      type: 'string',
      sortable: false,
      filterable: false,
      renderCell: (data) => (data.row.color ? <ColorCircleUi color={data.row.color} size={20} /> : ''),
    },
    {
      field: 'active',
      headerName: 'Aktív',
      type: 'boolean',
    },
  ]);

  return (
    <DatagridPremiumUi
      datagridIdentifier={DataGridIdentifiers.TagReportTable}
      datagridInitialState={initialState}
      dataLoader={getList}
      rows={reports.rows}
      refetch={{ refetchTable, setRefetchTable }}
      rowCount={reports.rowCount}
      columns={[...columns]}
      onRowClick={(rowData) => {
        if (!viewField) return;
        setSelectedValues(rowData.row);
      }}
      paginationAndfilterMode="server"
      onRowSelectionModelChange={(newRowSelectionModel) => {
        setRowSelectionModel(newRowSelectionModel);
      }}
      rowSelectionModel={rowSelectionModel}
      disableRowSelectionOnClick={!viewField}
    />
  );
};

export default TagReports;
